import * as React from 'react';
import { bootstrap } from './bootstrap';
import { useConfig } from '../../../../context';
import i18n from 'i18next';
let bootstrapPromise = null;
export const useBootstrapReady = () => {
    const config = useConfig();
    const [ready, setReady] = React.useState(() => {
        // Проверяем несколько индикаторов готовности
        return typeof window !== 'undefined' && window.__webskyEngineReady === true && i18n.isInitialized;
    });
    React.useEffect(() => {
        let cancelled = false;
        if (!bootstrapPromise) {
            bootstrapPromise = bootstrap(config);
        }
        bootstrapPromise.finally(() => {
            if (!cancelled) {
                setReady(true);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [config]);
    return ready;
};
